export enum AssetMappingStatus {
  MAPPED = 'mapped',
  UNMAPPED = 'unmapped',
}
